
<template>

      <UiModal
        :width="'300px!important'"
        :max-width="'300px!important'"
        title=""
        :is-dark="true"
        :is-auto-height="true"
        :is-rounded="true"
        :is-mobile-margin="true"
        @close="close(false)"
        class="confirm-modal"
        >

        <div class="imb">

          <div class="message">{{props.message}}</div>

          <UiButton
            :name="props.okText || 'OK'"
            :type="' link red wide'"
            @click="close(true)"
            />      

          <UiButton
            :name="props.cancelText || 'Cancel'"
            :tag="'NuxtLink'"
            :type="'link wide white'"
            @click="close(false)"
            />   

        </div>

      </UiModal>

</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { on } from 'events';
import { onMounted, onBeforeUnmount } from 'vue'

 // Props
const props = defineProps<{
  modelValue: boolean
  message: string
  okText?: string
  cancelText?: string
}>()

// Emits
const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'close', result: boolean): void
}>()

// Local reactive state
const show = useVModel(props, 'modelValue', emit)

// Close helper
function close(result: boolean) {
  emit('close', result)          // resolve promise in composable
  emit('update:modelValue', false)
}



// Listen for Enter (confirm) and Escape (cancel) keys while the modal is visible
const handleKey = (e: KeyboardEvent) => {
  // Ignore events when the modal is hidden
  if (!show.value) return

  if (e.key === 'Enter') {
    // Block default behaviour (e.g., form submission) and confirm
    e.preventDefault()
    close(true)
  } else if (e.key === 'Escape') {
    // Cancel and close the modal
    e.preventDefault()
    close(false)
  }
}

// Register the key listener when the component is mounted
onMounted(() => {
  if(!import.meta.client) return
  document.addEventListener('keydown', handleKey)
})

// Clean up the listener when the component is destroyed
onBeforeUnmount(() => {
  if(!import.meta.client) return
  document.removeEventListener('keydown', handleKey)
})



// onMounted(() => {
//   throw createError({
//     statusCode: 404,
//     statusMessage: 'failed to fetch dynamically imported module',
//   });
// })


</script>

<style scoped>
.confirm-modal {
  z-index: 9999999;
}

.message{
  font-size: 1rem;
  text-align: center;
  max-width: calc(100% - 3rem);
  margin: auto;
  margin-bottom: 0.7rem;
  color: #fff;
}
</style>
